@if(Form){
<div class="authForm-wrapper">
  <figure class="img-icon">
    <img width="327" height="273" src="assets/images/welcome-graphic.svg" alt="" />
  </figure>

  <h3>{{ "Welcome User" | translate }}</h3>
  <form [formGroup]="Form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="username-fld full-width">
      <mat-label>
        {{
        usernameType === "mobile"
        ? ("Mobile" | translate)
        : usernameType === "email"
        ? ("Email" | translate)
        : ("Email or Mobile" | translate)
        }}
      </mat-label>

      <input [class.pl-3]="usernameType === 'mobile'" matInput
        [placeholder]="'Enter email or mobile number' | translate" type="text" formControlName="username"
        (ngModelChange)="changeInputType()" />

      @if(usernameType === 'mobile'){
      <span matPrefix class="numPrefix">{{ "+1" | translate }}</span>
      }
      <mat-icon matSuffix>
        {{
        usernameType === "email"
        ? ("email" | translate)
        : usernameType === "mobile"
        ? ("call" | translate)
        : ""
        }}
      </mat-icon>
    </mat-form-field>

    <button mat-flat-button class="btn full-width" [disabled]="!Form.valid || loading">
      <span [class.vHidden]="loading">{{ "Next" | translate }}</span>
      @if(loading){
      <mat-spinner color="primary" diameter="20"></mat-spinner>
      }
    </button>
  </form>
</div>
}